export const EVENTS = {
  PRICE_PAGE_VIEW: 'PRICE_PAGE_VIEW',
  PURCHASE_CLICK: 'PURCHASE_CLICK',
  SIGN_UP_PAGEVIEW: 'SIGN_UP_PAGEVIEW',
  SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
  SIGN_IN_PAGEVIEW: 'SIGN_IN_PAGEVIEW',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  PLAN_SELECT_CLICK: 'PLAN_SELECT_CLICK',
  CHECKOUT_VIEW: 'CHECKOUT_VIEW',
  NEW_CHECKOUT_MODAL_VIEW: 'NEW_CHECKOUT_MODAL_VIEW',
  NEW_CHECKOUT_MODAL_VIEW_CONTROL: 'NEW_CHECKOUT_MODAL_VIEW_CONTROL',
  NEW_CHECKOUT_MODAL_VIEW_VARIANT: 'NEW_CHECKOUT_MODAL_VIEW_VARIANT',
  PAYMENT_SELECT_CLICK: 'PAYMENT_SELECT_CLICK',
  PAYMENT_SUBMIT_CLICK: 'PAYMENT_SUBMIT_CLICK',
  CHECKOUT_SUCCESS: 'CHECKOUT_SUCCESS',
  CHECKOUT_ERROR: 'CHECKOUT_ERROR',
  PAID_SUCCESS: 'PAID_SUCCESS',
  ATP_CROSS_SELL_MODAL_CLICK: 'ATP_CROSS_SELL_MODAL_CLICK',
  BUY_ADDON_CLICK: 'BUY_ADDON_CLICK',
  UNLOADED_REPORT_VIEW: 'UNLOADED_REPORT_VIEW',
  LOADED_REPORT_VIEW: 'LOADED_REPORT_VIEW',
  PROJECT_CREATION_CLICK: 'PROJECT_CREATION_CLICK',
  PROJECT_CREATION_SUCCESS: 'PROJECT_CREATION_SUCCESS',
  CANCEL_SUBSCRIPTION_SUCCESS: 'CANCEL_SUBSCRIPTION_SUCCESS',
  VIEW_REPORT: 'VIEW_REPORT',
  DASHBOARD_LANDING_PAGE_CONTROL: 'DASHBOARD_LANDING_PAGE_CONTROL',
  DASHBOARD_LANDING_PAGE_VARIANT: 'DASHBOARD_LANDING_PAGE_VARIANT',
  PROJECT_CREATION_SUCCESS_MODAL_CLICK: 'PROJECT_CREATION_SUCCESS_MODAL_CLICK',
  UPDATE_BILLING_INFORAMTION_UPDATED: 'UPDATE_BILLING_INFORAMTION_UPDATED',
  MONTHLY_TIER_1_PRICE_EXPERIMENT_CONTROL:
    'MONTHLY_TIER_1_PRICE_EXPERIMENT_CONTROL',
  MONTHLY_TIER_1_PRICE_EXPERIMENT_VARIANT:
    'MONTHLY_TIER_1_PRICE_EXPERIMENT_VARIANT',
  START_TRIAL: 'START_TRIAL',
  PLAIN_FILTER_CLICK: 'PLAIN_FILTER_CLICK',
  COPY_SUCCESS: 'COPY_SUCCESS',
  EXPORT_SUCCESS: 'EXPORT_SUCCESS',
  CHANGE_EMAIL_CLICK: 'CHANGE_EMAIL_CLICK',
  CHANGE_EMAIL_OLD_EMAIL_PASSWORD_WRONG:
    'CHANGE_EMAIL_OLD_EMAIL_PASSWORD_WRONG',
  CHANGE_EMAIL_SEND_CODE_TO_OLD_EMAIL: 'CHANGE_EMAIL_SEND_CODE_TO_OLD_EMAIL',
  CHANGE_EMAIL_CONTACT_US_OLD_EMAIL: 'CHANGE_EMAIL_CONTACT_US_OLD_EMAIL',
  CHANGE_EMAIL_OLD_EMAIL_VALIDATED: 'CHANGE_EMAIL_OLD_EMAIL_VALIDATED',
  CHANGE_EMAIL_OLD_EMAIL_CODE_ERROR: 'CHANGE_EMAIL_OLD_EMAIL_CODE_ERROR',
  CHANGE_EMAIL_RESEND_CODE_OLD_EMAIL: 'CHANGE_EMAIL_RESEND_CODE_OLD_EMAIL',
  CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_USER_BLOCKED:
    'CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_USER_BLOCKED',
  CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_CONTACT_SUPPORT:
    'CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_OLD_EMAIL_CONTACT_SUPPORT',
  CHANGE_EMAIL_OLD_EMAIL_CODE_VALIDATED:
    'CHANGE_EMAIL_OLD_EMAIL_CODE_VALIDATED',
  CHANGE_EMAIL_SEND_CODE_TO_NEW_EMAIL: 'CHANGE_EMAIL_SEND_CODE_TO_NEW_EMAIL',
  CHANGE_EMAIL_NEW_EMAIL_CODE_ERROR: 'CHANGE_EMAIL_NEW_EMAIL_CODE_ERROR',
  CHANGE_EMAIL_RESEND_CODE_NEW_EMAIL: 'CHANGE_EMAIL_RESEND_CODE_NEW_EMAIL',
  CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_USER_BLOCKED:
    'CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_USER_BLOCKED',
  CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_CONTACT_SUPPORT:
    'CHANGE_EMAIL_MAX_ATTEMPTS_EXCEEDED_NEW_EMAIL_CONTACT_SUPPORT',
  CHANGE_EMAIL_NEW_EMAIL_UPDATED: 'CHANGE_EMAIL_NEW_EMAIL_UPDATED',
  CHANGE_EMAIL_CLICK_ALERT_CONFIRM_EMAIL:
    'CHANGE_EMAIL_CLICK_ALERT_CONFIRM_EMAIL',
  CHANGE_EMAIL_CLICK_BANNER_CONFIRM_EMAIL:
    'CHANGE_EMAIL_CLICK_BANNER_CONFIRM_EMAIL',
  CHANGE_EMAIL_NOTIFICATION_CONFIRM_NEW_EMAIL:
    'CHANGE_EMAIL_NOTIFICATION_CONFIRM_NEW_EMAIL',
  CHOOSE_YOUR_SUCCESS_PATH_VIEW: 'CHOOSE_YOUR_SUCCESS_PATH_VIEW',
  CHOOSE_YOUR_SUCCESS_PATH_CTA_CLICKED: 'CHOOSE_YOUR_SUCCESS_PATH_CTA_CLICKED',
  UPLOAD_CSV_SUCCESS: 'UPLOAD_CSV_SUCCESS',
} as const
